import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import SubHeader from '../../../common/subHeader';
import Divider from '../../../common/divider';
import ATable from '../../../common/table';
import Constants from '../../../../configurations/constants';
import Messages from '../../../../configurations/messages';


const evidencesTableColumns = [
    {
        expander: true,
        header: "",
        accessor: "id",
    },
    {
        expander: true,
        header: "Date",
        accessor: "addedOn",
        render :  row => {return row.row.addedOn;},
        width: 250,
    },
    {
        expander: true,
        header: "Added By",
        accessor: "addedBy",
        render :  row => {return row.row.addedBy;},
        width: 300,
    },

    {
        expander: true,
        header: "Type",
        accessor: "mimeType",
        render :  row => {return row.row.mimeType;},
        width: 250,
    },
    {
        expander: true,
        header: "Tags",
        accessor: "tags",
        render :  row => {return row.row.tags;},
        width: 300,
    }

];


class DisputeModalEvidenceSection extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onRowClick = this.onRowClick.bind(this);
        this.state = {
            addedEvidences: [],
            currentEvidenceFiles: [],
            currentTag: '',
            fileUploadText: '',
        }
        this.onEvidenceFilesSelected = this.onEvidenceFilesSelected.bind(this);
        this.onTagChange = this.onTagChange.bind(this);
        this.onAddEvidenceButtonClicked = this.onAddEvidenceButtonClicked.bind(this);
        this.onAddedEvidencesChanged = this.onAddedEvidencesChanged.bind(this);
    }

    onRowClick(state) {

    }
    onEvidenceFilesSelected(event) {
        let target = event.target;
        let files = [];
        let fileNames = '';
        for (let i = 0; i < target.files.length; i++) {
            let file = target.files[i];
            files.push(file);
            fileNames += `${file.name}, `
        }

        this.setState({ currentEvidenceFiles: files, fileUploadText: fileNames });
    }
    onAddedEvidencesChanged(selectedOptions) {
        
        this.setState({ addedEvidences: selectedOptions });
        debugger;
        this.props.onEvidenceAddedHandler(selectedOptions.map(e => { return e.payload }));
    }
    onTagChange(event) {
        this.setState({ currentTag: event.target.value });
    }
    onAddEvidenceButtonClicked(event) {

        if (this.state.currentEvidenceFiles.length === 0) {
            Toaster.error(`${Messages.ERROR_EVIDENCE_NO_FILE_SELECTED}`)
            //Reset state 
            this.setState({ currentTag: '', fileUploadText: '' })
            return;
        }

        let files = this.state.currentEvidenceFiles.filter(file => {   //Filter for files that are too large

            if (file.size > Constants.MAXIMUM_EVIDENCE_FILE_SIZE) {
                Toaster.error(`${Messages.ERROR_FILE_TOO_LARGE} - ${Math.floor(Constants.MAXIMUM_EVIDENCE_FILE_SIZE / 1024)} KB`, `${Messages.ERROR_FILE_TOO_LARGE_TITLE} - ${file.name}`);
                return false;
            }
            return true
        });
        let tags = this.state.currentTag;

        files.forEach(file => {   //Detect images and add only valid types


            var fileReader = new FileReader();
            fileReader.onloadend = (e) => {
                //TODO find an alternate handler cos tis check happens after file bytes have been read
                if (this.state.addedEvidences.length >= Constants.MAXIMUM_EVIDENCE_UPLOAD_COUNT) {
                    Toaster.error(`${Messages.ERROR_EVIDENCE_ADD} ${file.name},  ${Messages.ERROR_MAXIMUM_EVIDENCE_UPLOAD_COUNT} - (${Constants.MAXIMUM_EVIDENCE_UPLOAD_COUNT})`)
                    return;
                }
                var fileArray = (new Uint8Array(e.target.result))
                var arr = fileArray.subarray(0, 4);
                var header = "";
                for (var i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
                }
                console.log(header);
                let type = "unknown";
                // Check the file signature against known types
                switch (header) {
                    case "89504e47":
                        type = "image/png";
                        break;
                    case "47494638":
                        type = "image/gif";
                        break;
                    case "ffd8ffe0":
                    case "ffd8ffe1":
                    case "ffd8ffe2":
                        type = "image/jpeg";
                        break;
                }
                if (type === "unknown") {
                    Toaster.error(`${Messages.ERROR_EVIDENCE_INVALID_FILE_TYPE}`, `${Messages.ERROR_EVIDENCE_INVALID_FILE_TYPE_TITLE} - ${file.name}`);
                    return;
                }
                //Convert to base 64 and add to selected
                let base64String = btoa(String.fromCharCode(...fileArray));

                let evidence = {
                    label: file.name,
                    value: file.name,
                    payload: {
                        mimeType: type,
                        tags: tags,
                        base64EncodedBinary: base64String
                    }

                }
                let addedEvidences = this.state.addedEvidences;
                addedEvidences.push(evidence);
                this.setState({ addedEvidences: addedEvidences });
                this.props.onEvidenceAddedHandler(addedEvidences.map(e => { return e.payload }));
                Toaster.success(file.name + " attached.");
            };
            fileReader.readAsArrayBuffer(file);
        });
        //Reset state 
        this.setState({ currentTag: '', currentEvidenceFiles: [], fileUploadText: '' })
        this.refs.evidenceFiles.value = "";
    }
    render() {
        return (
            <div>
                <Divider />
                <SubHeader title="Evidence" />
                <Divider />
                {!this.props.disableUpload && <div className="row evidence-upload-file">
                    <div className="col-md-6">
                        <div className="section">
                            <label>Select Evidence : </label>
                            <input type="file" multiple={true} ref="evidenceFiles" id="evidenceFiles" name="evidenceFiles" onChange={this.onEvidenceFilesSelected} />
                        </div>
                        <div className="section">
                            <label>Tags:</label>
                            <br />
                            <textarea placeholder="Add tags (optional)" value={this.state.currentTag} onChange={this.onTagChange} id="tag" name="tag" />
                        </div>
                        <button className="btn btn-primary" style={{ textAlign: "right" }} onClick={this.onAddEvidenceButtonClicked}>Attach Evidence</button>
                    </div>
                    <div className="col-md-6">
                        <label>Attached Evidence Files: </label>
                        <Select disabled={this.state.addedEvidences.length === 0} placeholder="No evidence file attached" multi={true} onChange={this.onAddedEvidencesChanged} options={this.state.addedEvidences} value={this.state.addedEvidences} />
                    </div>
                </div>
                }

                <ATable
                    className="-striped -highlight"
                    tableData={this.props.evidences}
                    columns={evidencesTableColumns}
                    loading={this.props.loading}
                    onRowClick={this.onRowClick}
                    defaultPageSize={5}
                    SubComponent={(rowObject) => {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <img src={`data:${rowObject.row.mimeType};base64, ${rowObject.row.base64EncodedBinary}`} alt="Could not load evidence" />
                            </div>
                        )
                    }}
                />


            </div>
        )
    }
}
export default DisputeModalEvidenceSection;





// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModalEvidenceSection.js